'use strict';
/**
 * @author Maxim Seredkin
 */


export default function () {
    return {
        restrict: 'A',
        template: require('../view/project-gchp-filter.html'),
        transclude: true,
        scope: {
            municipalities: '=municipalities',
            industries: '=industries',
            applyFilter: '=applyFilter',
        },
        controller: ['$scope', 'ProjectGchpFilterService', 'OperatorService', '$rootScope', '$utils',
            function ($scope, ProjectGchpFilterService, OperatorService, $rootScope, $utils) {

                $scope.localFilter = ProjectGchpFilterService.getFilters();
                $scope.selectSettings = { ...$rootScope.selectSettings };

                $scope.closeFilter = () => {
                    $scope.localFilter = ProjectGchpFilterService.getFilters();
                    $utils.openControlSidebar();
                }

                $scope.reset = () => {
                    $scope.localFilter = ProjectGchpFilterService.getDefaultFilters();
                    $scope.filterForm.$setPristine();
                }

                $scope.ok = (filters) => {
                    $utils.openControlSidebar();
                    $scope.applyFilter(filters);
                }
            }]
    };
}
